/* 🤖 this file was generated by svg-to-ts */
export const kzIconsPhoto: {
  name: 'photo';
  data: string;
} = {
  name: 'photo',
  data: `<svg viewBox="0 0 27 23"><g stroke="currentColor" stroke-width="1.2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M25.463 19.306a2.487 2.487 0 0 1-2.483 2.49H3.092a2.487 2.487 0 0 1-2.482-2.49V6.84a2.486 2.486 0 0 1 2.482-2.49H22.98a2.486 2.486 0 0 1 2.483 2.49v12.466ZM20.492 8.088h1.242"/><path d="M18.006 13.073a4.978 4.978 0 0 1-4.97 4.985c-2.745 0-4.97-2.232-4.97-4.985a4.977 4.977 0 0 1 4.97-4.984 4.977 4.977 0 0 1 4.97 4.984ZM8.065 4.35V2.48c0-1.033.835-1.87 1.863-1.87h6.215c1.03 0 1.863.837 1.863 1.87v1.87"/></g></svg>`
};
